const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: 'https://tomasjohannesson.com/',
  title: 'TJ.',
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'Tomas Johannesson',
  role: 'Engineer with a Passion for Building Scalable Systems',
  description: "At Carnegie Mellon University (CMU) and Reykjavik University I focused on **Systems and Machine Learning**. I've led impactful projects at Flexport as a **Full Stack Engineer**, including automatic route generation, redesigning an air fee payment system, optimizing performance, and reducing user interactions. My **previous projects** range from implementing Kernel PCA on GPU to launching a take-out platform in Iceland during COVID-19. I'm driven by a commitment to excellence and a desire to solve complex challenges with reliable, scalable technologies. **Welcome to my portfolio!**",
  resume: '/resume.pdf',
  social: {
    linkedin: 'https://www.linkedin.com/in/tomasjoh/',
    github: 'https://github.com/tomasjoh',
  },
  lightPortrait: 'light_portrait.jpg',
  darkPortrait: 'zleepy.gif'
}


const projects = [
  {
    name: "Kernel PCA on NVIDIA's RAPIDS Library",
    description:
      "Implemented Kernel PCA on NVIDIA's RAPIDS library. From 30 minutes to seconds, RAPIDSAI's KPCA shows **over 200x speedup** on certain datasets compared to scikit-learn. The project involved implementing the algorithm in **C++**, and creating a **Python** wrapper (following scikit-learn API) for the C++ code. The project also involved writing tests and benchmarks for the algorithm.",
    stack: ['C++', 'Python', 'Cython', 'CUDA'],
    image: 'kpcagif.gif',
    // sourceCode: 'https://github.com/rapidsai/cuml/pull/5988',
    // livePreview: 'https://github.com/rapidsai/cuml/pull/5988',
  },
  {
    name: 'EatUp',
    description:
      'Launched a take-out platform during COVID-19, leading a team to create a comprehensive system that included a **mobile app, homepage, payment and map integrations, and a restaurant portal**. Successfully onboarded dozens of restaurants, leading the platform to become the #1 app in the Icelandic app store.',
    stack: ['React', 'React-Native', 'TypeScript', 'Node.js', 'Express', 'PostgreSQL'],
    image: 'eatup.gif',
    // sourceCode: 'https://github.com',
    // livePreview: 'https://github.com',
  },
  {
    name: 'Blockchain digital certification',
    description:
      'Designed and led team of developers to create a multi-party digital certificate solution on blockchain. The system includes three roles: **issuer, verifier, and user**. The issuer (university) creates a certificate, the verifier (e.g. dean) digitally signs it, and the user (e.g. employer) uploads and verifies it on website.',
    stack: ['React', 'NodeJs', 'TypeScript', 'PostgreSQL', 'Hyperledger Fabric'],
    image: 'certs.gif',
    // sourceCode: 'https://github.com',
    // livePreview: 'https://github.com',
  },
  {
    name: 'Deep Learning competitions at CMU',
    description:
      'I implemented various Deep Learning algorithms with PyTorch, and regularly placing high in Kaggle competitions against other Carnegie Mellon University students. Implemented **Listen-Attend-Spell with weight tying** for Speech Recognition. Achieved **top 7.5%** performance with **Face Classification (CNN)** in CMU competition, achieving an accuracy of **87.7%**.',
    stack: ['Python', 'PyTorch', 'AWS'],
    image: 'DeepL.png',
    // sourceCode: 'https://github.com',
    // livePreview: 'https://github.com',
  },
]

// Timeline
const timeline = [
  {
    title: 'Software Engineer',
    company: 'Meta',
    years: '2024 - Present',
    lines: ['Software Engineer on the **Ads Experience Control** team'],
    type: 'work',
  },
  {
    title: 'Software Engineer II (L4)',
    company: 'Flexport',
    years: '2023 - 2024',
    lines: ['**Automatically** propagated air routes, **optimized** destination routing strategy, and **improved performance** in multiple key systems'],
    type: 'work',
  },
  {
    title: 'Software Engineer I (L3)',
    company: 'Flexport',
    years: '2022 - 2023',
    lines: ['Led project to **automatically generate** offerings and routes, led team projects to **reduce user interactions**, and **redesigned** air fee payment system'],
    type: 'work',
  },
  {
    title: 'Masters in Computer Science',
    company: 'Carnegie Mellon University',
    years: '2020 - 2021',
    lines: ['**Selected Courses:**', 'Database Systems (15-645)', 'Computer Networks (15-641)', 'Computer Architecture (15-740)', 'Deep Learning (11-785)', 'Parallel Computer Arch. and Programming (15-618)', 'Distributed Systems (15-640)', 'Machine Learning (10-601)'],
    type: 'education',
  },
  {
    title: 'Software Engineer Intern',
    company: 'Flexport',
    years: 'Summer 2021',
    lines: ['Built system to digitize and transmit air freight documents to airlines, **saving $20-60** per eligible shipment'],
    type: 'work',
  },
  {
    title: 'Software Engineer and Task Manager at Fintech Center',
    company: 'Reykjavik University',
    years: '2019 - 2020',
    lines: ['Developed a multi-party **digital certificate** solution', 'Coordinated and gave feedback to **four person team** as Task Manager'],
    type: 'work',
  },
  {
    title: 'Teaching Assistant',
    company: 'Reykjavik University',
    years: '2019 - 2020',
    lines: ['Computer Networks, Data Structures, Operating Systems, Algorithms, and Discrete Mathematics'],
    type: 'work',
  },
  {
    title: 'Bachelors in Computer Science',
    company: 'Reykjavik University',
    years: '2017 - 2019',
    lines: ["Dean's List 2017 and 2018", 'Top of class in 10 out of 13 classes in last 3 semesters'],
    type: 'education',
  },
  {
    title: 'Software Engineer Intern',
    company: 'scichess.com',
    years: 'Summer 2019',
    lines: ['Applied **Unity, C# and Python** to create a chess pattern recognition software for professionals and an auto-generated chess puzzle game for beginners'],
    type: 'work',
  },
  {
    title: 'Bachelors in Business Administration',
    company: 'Reykjavik University',
    years: '2014 - 2018',
    lines: ['Explored market conditions for self driving cars in Iceland for my thesis'],
    type: 'education',
  },
]


const skills = ['Java', 'Ruby on Rails', 'React', 'Python', 'C++', 'C', 'SQL', 'GraphQL', 'HTML', 'CSS', 'Postgres', 'NoSQL', 'Redis', 'Unix', 'Git', 'gRPC', 'CUDA', 'PyTorch', 'Kafka']

const contact = {
  email: 'tomas@tomasjohannesson.com',
}

export { header, about, projects, timeline, skills, contact }
